import { ApplicationConfig, LOCALE_ID, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withPreloading,
  PreloadAllModules,
  withRouterConfig,
} from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { importProvidersFrom, inject } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { jwtInterceptor } from '@core/interceptors/jwt/jwt.interceptor';
import { serverErrorInterceptor } from '@core/interceptors/server-error/server-error.interceptor';
import { AppInitializerService } from '@core/services';
import { LocalizationService } from './internationalization/localization.service';
import { LocalizationServiceConfig } from './internationalization/localization-config.service';
import { provideEchartsCore } from 'ngx-echarts';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),

    // Router
    provideRouter(
      routes,
      withComponentInputBinding(),
      withPreloading(PreloadAllModules),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
    ),

    // HTTP with functional interceptors (order matters: JWT first, then error handling)
    provideHttpClient(withInterceptors([jwtInterceptor, serverErrorInterceptor])),

    // Translation
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),

    // App initializer (from CoreModule)
    AppInitializerService,

    // Localization (from InternationalizationModule.forRoot)
    LocalizationService,
    { provide: LOCALE_ID, useValue: 'en-US' },
    { provide: LocalizationServiceConfig, useValue: { locale_id: 'en-US' } },
    provideEchartsCore({ echarts: () => import('echarts') }),

    // App initialization
    provideAppInitializer(() => {
      const appInit = inject(AppInitializerService);
      return appInit.initialize();
    }),
    provideAppInitializer(() => {
      const localization = inject(LocalizationService);
      return localization.initService();
    }),
  ],
};
